import { ITableRenderCell } from 'CorePackage/TableModule/interfaces/ITableRenderCell';
import { IKnmRaw } from 'KnmListPackage/MainModule/interfaces/IKnmRaw';
import { AccordionWithButton } from 'UIPackage/MainModule/components/AccordionWithButton';

import styles from './KnmListByPlanRequirementsList.module.scss';

export const KnmListByPlanRequirementsList = ({ row }: ITableRenderCell<IKnmRaw>) => {
  return (
    <>
      {row.requirementsList &&
        row.requirementsList.length > 0 &&
        (row.requirementsList.length > 1 ? (
          <>
            <div className={styles.MultiListTitle}>{row.requirementsList[0]?.title}</div>
            <div className={styles.MultiListName}>{row.requirementsList[0]?.nameNpa}</div>
            <div className={styles.MultiListDate}>{row.requirementsList[0]?.numberNpa}</div>
            <AccordionWithButton
              content={row.requirementsList
                .filter((item, index) => item && index > 0)
                .map(item => (
                  <>
                    <div className={styles.MultiListTitle}>{item?.title}</div>
                    <div className={styles.MultiListName}>{item?.nameNpa}</div>
                    <div className={styles.MultiListDate}>{item?.numberNpa}</div>
                  </>
                ))}
            />
          </>
        ) : (
          <>
            <div className={styles.MultiListTitle}>{row.requirementsList[0]?.title}</div>
            <div className={styles.MultiListName}>{row.requirementsList[0]?.nameNpa}</div>
            <div className={styles.MultiListDate}>{row.requirementsList[0]?.numberNpa}</div>
          </>
        ))}
    </>
  );
};
